<template>
  <div>
    <breadcrumbs :breadcrumbs="breadcrumbs"></breadcrumbs>
    <div class="innerWrapper" :class="{'mobile': mobile}">
      <div v-if="mobile" class="navigation">
        <div class="ui menu" :class="{'three item': sharedMemoSets && sharedMemoSets.length, 'two item': !sharedMemoSets || !sharedMemoSets.length}" style="background-color: #f0f1f2">
          <router-link class="item noBorderRadius" to="memo-sets">My Memo Sets</router-link>
          <router-link class="item noBorderRadius" to="shared-memo-sets" v-show="sharedMemoSets && sharedMemoSets.length">Shared With Me</router-link>
          <router-link class="item noBorderRadius" to="public-memo-sets">Public Memo Sets</router-link>
        </div>
      </div>
      <h3 class="ui header summaryHeader">Summary</h3>
      <div class="ui center aligned segment statisticsWrapper" :class="{'mobile': mobile}">
        <div class="ui statistics" :class="{'small': !mobile, 'tiny mobile': mobile}" style="display: block">
          <div class="purple statistic">
            <div class="value">
              <i class="table icon"></i>
              {{ summary.activeMemoSets }}
            </div>
            <div class="label">
              Active memo sets
            </div>
          </div>
          <div class="green statistic">
            <div class="value">
              <i class="check icon"></i>
              {{ summary.itemsKnown }}
            </div>
            <div class="label">
              Items known
            </div>
          </div>
          <div class="orange statistic">
            <div class="value">
              <i class="calendar outline icon"></i>
              {{ summary.itemsDue }}
            </div>
            <div class="label">
              Items due for review
            </div>
          </div>
        </div>
      </div>
      <div class="ui center aligned segment congratulations" v-show="!reviewMemoSets.length">
        <div><i class="large green checkmark box icon"></i></div>
        <div>Everything is up to date. Congratulations!</div>
      </div>
      <div v-show="reviewMemoSets.length">
        <h3 class="ui header reviewMemoSetsHeader">Ready for Review</h3>
        <div class="tableWrapper" :class="{'mobile': mobile}">
          <table
            class="ui selectable unstackable table"
            :class="{'compact': mobile}"
          >
            <thead>
              <tr>
                <th class="two wide">{{ text.memoSetsColumnImage }}</th>
                <th class="six wide">{{ text.memoSetsColumnMemoSet }}</th>
                <th class="two wide">Due</th>
                <th class="four wide">{{ text.commonStatus }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="memoSet in reviewMemoSets"
                :key="memoSet.memoSetId"
              >
                <td class="imgCell">
                  <router-link :to="'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug">
                    <div class="coverImageWrapper">
                      <img class="ui centered rounded image" :src="memoSet.coverImage">
                    </div>
                  </router-link>
                </td>
                <td>
                  <router-link :to="'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug">
                    {{ memoSet.title }}
                  </router-link>
                </td>
                <td class="locationNum">
                  <router-link :to="'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug">
                    <span :class="{'indent1': memoSet.statuses.due < 1000, 'indent2': memoSet.statuses.due < 100, 'indent3': memoSet.statuses.due < 10}">{{ memoSet.statuses.due }}</span>
                  </router-link>
                </td>
                <td>
                  <router-link :to="'memo-sets/' + memoSet.memoSetId + '/' + memoSet.slug">
                    <status-bar
                      :mobile="mobile"
                      page="Home"
                      :statuses="memoSet.statuses"
                      :window="window"
                      v-show="memoSet.statuses"
                    ></status-bar>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import StatusBar from '@/components/StatusBar'
export default {
  name: 'home',
  components: {
    Breadcrumbs,
    StatusBar
  },
  data () {
    return {}
  },
  computed: {
    breadcrumbs: function () {
      return [
        {label: this.text.navHome}
      ]
    },
    reviewMemoSets: function () {
      // TODO - handle initial loading and case where user has no memo sets
      if (!this.memoSets) return []
      if (!this.statuses) return []
      let reviewMemoSets = this.memoSets.map(memoSet => {
        let statuses = Object.assign({}, this.statuses[memoSet.memoSetId] || {})
        statuses.speed = 'slow'
        return {
          coverImage: memoSet.coverImage,
          docId: memoSet.docId,
          memoSetId: memoSet.memoSetId,
          slug: memoSet.slug,
          statuses: statuses,
          title: memoSet.title
        }
      }).filter(memoSet => memoSet.statuses.due > 0)
      // Sort memo sets by number of due items
      reviewMemoSets.sort((a, b) => {
        return a.statuses.due - b.statuses.due
      })
      return reviewMemoSets
    },
    summary: function () {
      let summary = {
        activeMemoSets: 0,
        itemsKnown: 0,
        itemsDue: 0
      }
      Object.keys(this.statuses).forEach(memoSet => {
        summary.activeMemoSets++
        summary.itemsKnown += this.statuses[memoSet].known
        summary.itemsDue += this.statuses[memoSet].due
      })
      return summary
    }
  },
  created: function () {
    // TEMP - for debugging
    window.vmHome = this
    // Set memo set source - used by the MemoSet component
    window.aoms = window.aoms || {}
    window.aoms.memoSetSource = 'Home'
    this.setPageTitle()
  },
  methods: {
    setPageTitle: function () {
      if (this.text && this.text.navHome) {
        document.title = this.text.navHome + ' - MemQ'
      }
    }
  },
  props: ['memoSets', 'mobile', 'sharedMemoSets', 'statuses', 'text', 'touch', 'user', 'window'],
  watch: {
    text: function (newText) {
      this.setPageTitle()
    }
  }
}
</script>

<style scoped>
  .coverImageWrapper {
    max-width: 160px;
  }
  img {
    max-height: 80px !important;
    max-width: 160px !important;
  }
  /* Make table rows a minimum height */
  .imgCell {
    height: 100px;
  }
  .ui.table thead tr th {
    background-color: #395f7f;
    color: rgba(255, 255, 255, 0.87)
  }
  .ui.table tbody tr td.selectable, .ui.ui.selectable.table>tbody>tr {
    background-color: #ffffff;
  }
  .ui.table tbody tr td.selectable:hover, .ui.ui.selectable.table>tbody>tr:hover {
    background-color: #e6e9ef;
  }
  .noTopMargin {
    margin-top: 0 !important;
  }
  .noTopPadding {
    padding-top: 0 !important;
  }
  /* Move padding from td to td > a to allow anchor to work in entire cell */
  td {
    padding: 0 !important;
    overflow: hidden;
  }
  td > a {
    color: rgba(0,0,0,.87);
  }
  /* Make <a> within <td> fill the entire cell, as per https://stackoverflow.com/a/15801081 */
  td {
    overflow: hidden;
  }
  td > a {
    display: block;
    margin: -5em;
    padding: 5.4em;
  }
  .statisticsWrapper {
    background-color: #ffffff;
  }
  .statisticsWrapper.mobile {
    border-left: none;
    border-radius: 0;
    border-right: none;
  }
  /* Override Semantic's negative margins */
  .ui.statistics {
    margin-left: 0;
    margin-right: 0;
  }
  /* Style for statistics labels */
  .ui.statistics .statistic>.label {
    padding-top: 5px;
    text-transform: none;
  }
  .ui.statistics:not(.mobile) .statistic>.label {
    font-size: 115%;
  }
  /* Move navigation section up */
  .navigation {
    margin-top: -1rem;
  }
  .navigation a {
    background-color: #f1f2f3 !important;
    font-weight: 700 !important;
  }
  .navigation a:hover {
    background-color: #d1d2d4 !important;
  }
  /* Make border between navigation buttons darker */
  .ui.menu .item:before {
    background-color: silver;
  }
  /* Add space after wide icons */
  .table.icon, .calendar.icon {
    margin-right: 0.3rem !important;
  }
  .congratulations {
    background-color: #e5f9e7;
    box-shadow: 0 0 0 1px #1ebc30 inset, 0 0 0 0 transparent;
    color: #1aa62a;
    font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
    font-size: 1.14285714em;
    font-weight: 700;
  }
  .congratulations > div {
    display: inline-block;
  }
  .congratulations .icon {
    color: #1ebc30;
    font-size: 3em !important;
  }
  .summaryHeader {
    margin-top: 1rem;
  }
  /* Reduce size of images on mobile */
  .tableWrapper.mobile img {
    max-height: 60px !important;
    max-width: 100px !important;
  }
  /* Reduce minimum height of table rows on mobile */
  .tableWrapper.mobile .imgCell {
    height: 74px;
  }
  .reviewMemoSetsHeader {
    margin-top: 2rem !important;
  }
  /* Add left margin to headings on mobile */
  .innerWrapper.mobile h3 {
    margin-left: 1rem !important;
  }
  .noBorderRadius {
    border-radius: 0 !important;
  }
  .indent1 {
    margin-left: 0.5em;
  }
  .indent2 {
    margin-left: 1em;
  }
  .indent3 {
    margin-left: 1.5em;
  }
  /* Improve multi-line tab labels */
  .ui.menu .item {
    line-height: 1.2;
    padding: 0 0.8rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue